import { Container, Row, Col, Card, CardBody } from "reactstrap";
import "../../assets/css/dashboard-redesign.css";
import { useNavigate } from "react-router-dom";
import { KPI_CARDS } from "utils/constant.js";

const Header = ({ stats }) => {
  const navigate = useNavigate();

  const formatValue = (num) => {
    if (num === null || num === undefined) return "--";

    if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
    if (num >= 1000) return (num / 1000).toFixed(1) + "K";

    return num.toString();
  };

  const getValue = (key) => {
    const val = stats?.[key];
    if (key === "walletVolume") return val || "--";
    return formatValue(val);
  };

  return (
    <div className="header dashboard-header-bg pb-8 pt-md-1">
      <Container fluid>
        <div className="header-body">

          {/* Header */}
          <Row className="align-items-center mb-3">
            <Col lg="12">
              <h2 className="system-overview-title text-white pt-3">
                System Overview
              </h2>
              <p className="system-overview-subtitle mb-0">
                Real-time performance metrics across the platform ecosystem.
              </p>
            </Col>
          </Row>

          {/* KPI Cards */}
          <Row className="">
            {KPI_CARDS.map((card, index) => (
              <Col 
              lg="4" xl="2" 
              key={index} className="d-flex py-3">
                <Card className="kpi-card border-0 w-100 h-100">
                  <CardBody className="p-3 d-flex flex-column justify-content-between">

                    {/* TOP SECTION */}
                    <div>

                      {/* Icon */}
                      <div
                        className="kpi-icon-container"
                        style={{ backgroundColor: card.bgColor }}
                      >
                        <i className={`${card.icon} ${card.iconClass}`} />
                      </div>

                      {/* Trend */}
                      <div className={`kpi-trend-top-right ${card.trendClass}`}>
                        {card.isBadge ? (
                          <span style={{ fontSize: "0.65rem" }}>
                            {card.trend}
                          </span>
                        ) : (
                          <>
                            <i className="fas fa-chart-line mr-1" />
                            {card.trend}
                          </>
                        )}
                      </div>

                      {/* Label */}
                      <div className="kpi-label">
                        {card.label}
                      </div>

                    </div>

                    {/* VALUE SECTION (FIXED ALIGNMENT) */}
                    <div
                      className={card.valueClass}
                      // style={{
                      //   cursor: card.route ? "pointer" : "default",
                      //   marginTop: "10px",
                      //   fontSize: card.key === "walletVolume" ? "16px" : undefined,
                      // }}
                      onClick={() =>
                        card.route && navigate(card.route)
                      }
                    >
                      {getValue(card.key)}
                    </div>

                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

        </div>
      </Container>
    </div>
  );
};

export default Header;